import React from "react";
import LoadingSkeleton from "../general/skeleton";

export const SettingsCard = ({ title, loading, customWidth, children }) => {
  return (
    <LoadingSkeleton loading={loading}>
      <div 
        className={`h-full bg-white relative px-3 py-2 rounded-2xl font-nexa flex flex-col justify-start 
          ${customWidth ? customWidth : "inline-flex w-auto"}`}
      >
        <h2 className="font-nexa text-xl text-primary-dark leading-10 m-0 mb-2">{title}</h2>
        <div className="w-full pb-2">
          {children}
        </div>
      </div>
    </LoadingSkeleton>
  );
};
